import { ICON_WARNING_FILL } from '@repo/assets';
import styled from 'styled-components';

type Props = {
  nationality?: string;
};

export const DepartureWarning = ({ nationality = 'ENG' }: Props) => {
  const nationIndex = nationality === 'KOR' ? 1 : 0;
  const text = {
    line1: [
      'If you left without customs verification,',
      '세관 확인을 받지 못하고 출국하신 경우,',
    ],
    line2: ['you can revisit', ''],
    highlight: [
      'Korea within 3 months with your purchased items and receipts',
      '구매하신 물품과 영수증을 지참하여 3개월 이내',
    ],
    line3: [
      'to receive customs verification and get your refund.',
      '에 다시 한국을 방문하시면 세관 확인을 받으시고 환급을 받으실 수 있습니다.',
    ],
  };

  return (
    <Container>
      <IconWrapper>
        <Icon src={ICON_WARNING_FILL} alt='' />
      </IconWrapper>
      <TextWrapper>
        <Text>{text.line1[nationIndex]}</Text>
        <Text>
          {text.line2[nationIndex]}{' '}
          <Highlight>{text.highlight[nationIndex]}</Highlight>{' '}
          {text.line3[nationIndex]}
        </Text>
      </TextWrapper>
    </Container>
  );
};

const Container = styled.div`
  background: #f4f4f4;
  border-radius: 6px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 14px;
`;

const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Icon = styled.img`
  width: 24px;
  height: 24px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  text-align: center;
  width: 100%;
`;

const Text = styled.p`
  font-family: 'Pretendard', sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: -0.26px;
  color: #111111;
  margin: 0;
  text-align: center;
`;

const Highlight = styled.span`
  color: #ed0828;
`;

export default DepartureWarning;
